
export function formatDateTime(inputDate) {
    if (inputDate && inputDate !== "") {
        let dateObj = new Date(inputDate);
        let month = getMonth(dateObj);
        let date = getDate(dateObj);
        let currentDate = `${date}-${month}-${dateObj.getFullYear()} ${('0' + dateObj.getHours()).slice(-2)}:${('0' + dateObj.getMinutes()).slice(-2)}:${('0' + dateObj.getSeconds()).slice(-2)}`;
        return currentDate;
    } else {
        return inputDate;
    }
}

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export function formatDate(inputDate) {
    if (!inputDate || inputDate === "") return inputDate;
    const months = MONTHS;
    // yyyy-mm-dd (from <input type="date">)
    const yyyymmdd = /^(\d{4})-(\d{2})-(\d{2})$/.exec(inputDate);
    if (yyyymmdd) {
        const d = yyyymmdd[3], m = parseInt(yyyymmdd[2], 10) - 1, y = yyyymmdd[1];
        return `${d} ${months[m]} ${y}`;
    }
    // dd-mm-yyyy (from API)
    const ddmmyyyy = /^(\d{2})-(\d{2})-(\d{4})$/.exec(inputDate);
    if (ddmmyyyy) {
        const d = ddmmyyyy[1], m = parseInt(ddmmyyyy[2], 10) - 1, y = ddmmyyyy[3];
        return `${d} ${months[m]} ${y}`;
    }
    // ISO / other parseable formats
    const dateObj = new Date(inputDate);
    if (isNaN(dateObj)) return inputDate;
    return `${getDate(dateObj)} ${months[dateObj.getMonth()]} ${dateObj.getFullYear()}`;
}

const getMonth = (dateObj) => {
    let currentMonth = dateObj.getMonth() + 1 <= 9 ? "0" + (dateObj.getMonth() + 1) : dateObj.getMonth() + 1;
    return currentMonth;
};

const getDate = (dateObj) => {
    let currDate = dateObj.getDate() <= 9 ? "0" + dateObj.getDate() : dateObj.getDate();
    return currDate;
};

export function convertDateTimetoDateFormat(dateTime) {
    if (dateTime && dateTime !== "" && dateTime !== "null") {
        let dateObj = new Date(dateTime);
        let month = getMonth(dateObj);
        let date = getDate(dateObj);
        let currentDate = `${dateObj.getFullYear()}-${month}-${date}`;
        return currentDate;
    } else {
        return "";
    }
}

export function convertDateForPicker(dateTime) {
    if (dateTime && dateTime !== "" && dateTime !== "null") {
        let dateObj = new Date(dateTime);
        let month = getMonth(dateObj);
        let date = getDate(dateObj);
        let currentDate = `${date}/${month}/${dateObj.getFullYear()}`;
        return currentDate;
    } else {
        return "";
    }
}

export function addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
}

export function getDateYear(inputDate) {
    const dateParts = inputDate.split('-');
    
    if (dateParts.length === 3) {
        const year = dateParts[0];
        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const monthIndex = parseInt(dateParts[1], 10) - 1;
        let month = months[monthIndex];
        return `${month}, ${year}`;
    } else {
        return "";
    }
}